import { useAppSelector } from 'reduxTyped'

import { Ability } from '../constants/Ability'
import { getAbilities } from '../selectors/abilitiesSelectors'

/**
 * A hook that accepts requested `Ability` and returns `true`
 * if current account has the ability
 *
 * @example
 * const hasSomeAbility = useAbility(Ability.SOME_ABILITY)
 */
export const useAbility = <A extends Ability>(requestedAbility: A) => {
  const abilities = useAppSelector(getAbilities)

  return Boolean(abilities[requestedAbility])
}
